import { css } from '@emotion/css'
import { spacing, fontSize, fontWeight, fontFamily } from '../../../styles'
import { shorthandHelper } from '../../../styles/helpers'
import getThemeColors, { colors } from '../../../themes'

const styles = {
  item: css({
    display: 'flex',
    alignItems: 'stretch',
    fontSize: fontSize.default,
    fontWeight: fontWeight.regular,
    fontFamily: fontFamily.body,
    lineHeight: 1.2,
    color: colors.jumbo,
    margin: shorthandHelper([0, spacing.medium]),
  }),

  link: css({
    display: 'flex',
    alignItems: 'center',
    borderTop: '3px solid transparent',
    borderBottom: '3px solid transparent',
    color: 'inherit',
    textDecoration: 'none',

    '&:hover': {
      textDecoration: 'none',
      color: colors.oxfordBlue,
    },

    '&:focus': {
      outline: 'none',
    },
  }),

  activeLink: css({
    color: colors.oxfordBlue,
  }),
}

export default styles

export const activeLinkTheme = theme => {
  const themed = getThemeColors(theme)

  return css({
    borderBottomColor: themed.base,
  })
}
